import { t, getWeekDay, getDayAndMonth, getFullMinute } from "../../../services/formatters";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import widgetOptions from "../../../config/widgets.json";
import { useFilialiDirectPage } from "./useFilialiDirectPage";
import { Button } from "../../../components/Button";
import { ErrorModal } from "../../../components/ErrorModal";
import { useEffect } from "react";
import { TextInput } from "../../../components/TextInput";
import { EditAppointmentModal } from "../../../components/EditAppointmentModal";
import "@splidejs/splide/dist/css/splide.min.css";
import "./FilialiDirectPage.css";
import { useComponentMetric } from "../../../lib/otel";

export const FilialiDirectC5Page = () => {
    const {
        next,
        read,
        update,
        daySlider,
        onGiorniSlideChange,
        isFilialiSlideBusy,
        fetchErrorMessage,
        fetchError,
        onCfChange,
        setFetchError,
        isDatiUtenteReady,
        isCfFetchStart,
        getCfInputState,
        showModal,
        closeModal,
    } = useFilialiDirectPage();

const metric = useComponentMetric("filiali-direct-c5");
    useEffect(() => {
        window.dataLayer.push({
            event: "customPageview",
            virtualPageURL: "/fa3/fissa-appuntamento/scegli-filiale-direct-c5",
            funnelVersion: "nuovo",
            capFiliale: read("cap"),
            presa_info: read("solo_info"),
        });
    }, []);

    useEffect(() => {
        if (fetchError) {
            metric.trackError(fetchErrorMessage || "errore recupero filiali");
        }
    }, [fetchError]);


    return (
        <div id="filiali-page-direct">
            <div className={`section page-title-component center-on-tablet`}>
                <h1 className="title-subito-apuntamento">
                    <span>
                        Fissa subito un appuntamento per la <strong>Cessione del Quinto</strong>
                    </span>
                    <br />
                </h1>
                <p className="fa-direct-header">
                    Ti proponiamo la prima data disponibile in questa{" "}
                    <span className="filiale-name-title">
                        <b>{read("filialeScelta").RagioneSociale}</b>
                    </span>
                </p>
            </div>

            {/* giorni */}
            <div id="days-splide" className="section full-screen on-mobile">
                <div className="fade"></div>
                <Splide
                    ref={daySlider}
                    options={widgetOptions.splideGiorni}
                    onMove={() => {}}
                    onDragging={() => {}}
                    onMoved={(splide, newIdx) => {
                        onGiorniSlideChange(newIdx);
                    }}
                    onReady={() => {}}>
                    {read("disponibilita").map((i, idx) => (
                        <SplideSlide key={`${i.data}-${idx}`}>
                            <div className={`white-box day-card-component text-uppercase clickable ${idx == 99 ? "show-next-days" : ""}`}>
                                <h2 className="actual-date">
                                    {getWeekDay(i.data, true)}
                                    {getWeekDay(i.data, true) && <br />}
                                    <span dangerouslySetInnerHTML={{ __html: getDayAndMonth(i.data, true) || "" }}></span>
                                </h2>

                                <h2 className="fake-date">Mostra successive</h2>
                            </div>
                        </SplideSlide>
                    ))}
                </Splide>
            </div>

            {/* ore */}
            <div className={`hour-grid-component`}>
                {isFilialiSlideBusy() && (
                    <>
                        <div className="sliders-loader loading-placeholder hours-loader"></div>
                    </>
                )}
                <div className="hours-grid-filiare-direct">
                    {read("orari").map((i, idx) => (
                        <div
                            key={`hour-grid-${idx}`}
                            onClick={() => {
                                if (!i.disponibile) return;
                                update("orarioScelto", { idx, hour: i.hour, minute: i.minute });
                            }}
                            className={`white-box hour-cell flex-cell ${
                                read("orarioScelto") && i.hour == read("orarioScelto").hour && read("orarioScelto") && i.minute == read("orarioScelto").minute && i.disponibile == true
                                    ? "is-active"
                                    : ""
                            } ${!i.disponibile ? "disabled" : ""}`}>
                            <h2>{`${i.hour}:${getFullMinute(i.minute)}`}</h2>
                        </div>
                    ))}
                </div>
            </div>

            {/* <CodiceFiscaleInsertion /> */}
            <div className={`section white-box input-box-component`}>
                <h2>{t("ci_conosciamo")}</h2>
                <p className={`input-box-subtitle`}>&nbsp;</p>
                <TextInput state={getCfInputState()} name="codiceFiscale" placeholder={t("inserisci_cf")} value={read("codiceFiscale")} onChange={onCfChange} maxLength={16}></TextInput>
            </div>

            <div className="text-small">
                <strong>
                    Prendi visione dell'informativa resa da Compass ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 e della normativa nazionale vigente in materia di protezione dei dati
                    personali{" "}
                    <a target="_blank" href="/share/pdfsni/PRIVACY_FA.PDF">
                        <u>qui scaricabile</u>
                    </a>
                </strong>
            </div>

            <br />
            <div className="section text-center">
                <Button id="go-to-select-state-btn" disabled={!isDatiUtenteReady()} onClick={next} classList="btn-responsive always-style" loading={isCfFetchStart()} text={`${t("avanti")}`} />
            </div>

            <ErrorModal
                open={fetchError}
                text={fetchErrorMessage}
                onCloseModal={() => {
                    setFetchError(false);
                }}></ErrorModal>

            <EditAppointmentModal open={showModal} title={t("modifica_appuntamento")} text={t("modifica_appuntamento_esistente_unknown_nocf")} onCloseModal={closeModal} />
        </div>
    );
};
